define("Address.Utils", [
  "Profile.Model",
  "LiveOrder.Model",
  "Singleton",
  "Utils",
  "SDB.SDBLocations.Model",
  "Manage.LocationAddress.Model",
  "Backbone",
], function (
  ProfileModel,
  LiveOrderModel,
  Singleton,
  Utils,
  LocationsModel,
  ManageLocationAddressModel,
  Backbone
) {
  "use strict";

  var Profile = ProfileModel.getInstance();
  var LiveOrder = LiveOrderModel.getInstance();
  var Locations = LocationsModel.getInstance();

  var addressUtils = function addressUtils(options) {
    var self = this;
    this.addressId = "";

    this.options = options || {};
    this.Application = this.options.Application || SC.Application;

    _.extend(this, Backbone.Events);

    var Env = this.Application.getComponent("Environment");

    this.profileAddresses = Profile.get("addresses");
    this.orderAddresses = LiveOrder.get("addresses");
    this.model = ManageLocationAddressModel.getInstance();

    this._addressId = function _addressId(id) {
      if (id && id !== this.addressId) {
        this.addressId = id;
      } else if (!this.addressId) {
        var customfields = Profile.get("customfields");
        var addressField = _.find(customfields, {
          name: "custentity_sdb_location_address_id",
        });

        if (addressField && addressField.value) {
          this.addressId = addressField.value;
        }
      }

      this.trigger("change:addressId", this, this.addressId);
      return this.addressId;
    };

    this.pickLocationAddress = function pickLocationAddress(location) {
      if (_.isUndefined(location)) return false; // return false if location is undefined
      var addrObj = {
        defaultbilling: "F",
        defaultshipping: "T",
        isresidential: "F",
        fullame: location.addressee,
      };

      if (_.has(location, "addrFields")) {
        /* Replace each null property by an empty string */
        addrObj = _.extend(addrObj, location.addrFields);
        addrObj = _.mapObject(addrObj, function (value) {
          if (!value) value = "";
          return value;
        });
      } else {
        var fieldsToOmit = [
          "internalid",
          "parent",
          "name",
          "address",
          "selected",
          "email",
        ];
        addrObj = _.omit(location, fieldsToOmit);
      }

      var countries = Env.getConfig("siteSettings.countries");
      var currentCountry = _.find(countries, { name: addrObj.country });
      if (currentCountry && currentCountry.code)
        addrObj.country = currentCountry.code;

      _.extend(addrObj, _.pick(location, "phone"));
      return addrObj;
    };

    this.setShipAddress = function setShipAddress(addressId) {
      // if (Utils.isInShopping()) return;
      if (Backbone.history.location.pathname.indexOf("checkout") === -1) return;
      if (!addressId)
        addressId = !this.profileAddresses.isEmpty()
          ? this.profileAddresses.at(0).id
          : "";
      if (!addressId) return;
      var shipAddress = LiveOrder.get("shipaddress");

      if (shipAddress === this._addressId()) {
        // if (Backbone.history.location.pathname.indexOf('checkout') === -1) {
        //     LiveOrder.setAddress('shipaddress', addressId, { wait: true, validate: false });
        // }
        // else $('[class*="OrderWizard.Module.Address.Shipping"] input[data-id="' + addressId + '"]').click();
        $(
          '[class*="OrderWizard.Module.Address.Shipping"] input[data-id="' +
            addressId +
            '"]'
        ).click();
      }
      var options = LiveOrder.get("options");
      options.custbody_sdb_store_ext_inv_data = Locations.get(
        "custbody_sdb_store_ext_inv_data"
      );
      options.custbody_sdb_store_int_inv_data = Locations.get(
        "custbody_sdb_store_int_inv_data"
      );
      // console.log('starting', 'first save')
      LiveOrder.save().then(function () {
        // console.log('ending', 'first save')
        Locations.set("finishedAddressManagement", true);
        // Locations.set('finishedAddressManagementMyAccount', (new Date()).toJSON());
      });
      // return;
      // return LiveOrder.setAddress('shipaddress', addressId, { wait: true, validate: false })
      //     .then(function () {
      //         var shipAddress = LiveOrder.get('shipaddress');

      //         // LiveOrder.save();
      //         // LiveOrder.setAddress('billaddress', '', { wait: true, validate: false }).then(function () {
      //         // });
      //     });
    };

    this.updateAddressCollections = function updateAddressCollections(
      newAddressId
    ) {
      if (Utils.isInShopping()) {
        LiveOrder.setAddress("shipaddress", newAddressId, {
          wait: true,
          validate: false,
        }).then(function () {
          // console.log('starting', 'second save')
          LiveOrder.save().then(function () {
            // console.log('ending', 'second save')
          });
        });
        return;
      }
      var self = this;
      var addressesCollections = [this.profileAddresses, this.orderAddresses];
      var update_promise = jQuery.when.apply(
        jQuery,
        _.invoke(addressesCollections, "fetch", {})
      );
      self._addressId(newAddressId);
      update_promise
        .then(function (profileResponse, orderResponse) {
          if (Backbone.history.location.pathname.indexOf("checkout") !== -1) {
            $(
              '[class*="OrderWizard.Module.Address.Shipping"] input[data-id="' +
                newAddressId +
                '"]'
            ).click();
            var options = LiveOrder.get("options");
            options.custbody_sdb_store_ext_inv_data = Locations.get(
              "custbody_sdb_store_ext_inv_data"
            );
            options.custbody_sdb_store_int_inv_data = Locations.get(
              "custbody_sdb_store_int_inv_data"
            );
            // console.log('starting', 'third save')
            LiveOrder.save().then(function () {
              // console.log('ending', 'third save')
              Locations.set("finishedAddressManagement", true);
            });
          } else if (!Utils.isInShopping()) {
            $(
              '[class*="OrderWizard.Module.Address.Shipping"] input[data-id="' +
                newAddressId +
                '"]'
            ).click();
          }
          // if (!(Utils.isInShopping())) {
          //     LiveOrder.setAddress('shipaddress', newAddressId, { wait: true, validate: false })
          //         .then(function () {
          //             Locations.set('finishedAddressManagementMyAccount', (new Date()).toJSON());
          //         })
          // }
        })
        .catch(console.error);

      return update_promise;
    };

    this.shipAddrChangeHandler = function shipAddrChangeHandler(
      model,
      shipaddress
    ) {
      if (Utils.isInShopping()) return;
      var locationAddrId = self._addressId();
      if (!locationAddrId) return;
      if (!Number(shipaddress)) return;
      if (shipaddress !== locationAddrId) {
        Locations.setCookie({ shoppingExperience: "online" });
      }
    };

    LiveOrder.on("change:shipaddress", this.shipAddrChangeHandler);
  };

  return _.extend(addressUtils, Singleton);
});
